import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Sensor } from './sensors/sensor';
import { Actuator } from './actuators/actuator';
import { statusColor } from '../../../../../core/util/machine.util';

@Component({
    selector: 'machine-widget',
    templateUrl: 'machine-widget.component.html',
    styleUrls: ['./machine-widget.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
})
export class MachineWidgetComponent implements OnInit {
    @Input() title: string;
    @Input() product: string = "Sin producto";
    @Input() sensors: Sensor[];
    @Input() actuators: Actuator[];
    @Input() grid: '2sh1'|'1s1'|'3s1'|'2sv1'; // <n sensors>s<orientation?><version>
    @Input() active: boolean = false;
    @Input() working: boolean = false;
    @Input() shiftHasData: boolean = false;
    @Output() changeActuator = new EventEmitter<any>();
    @Output() clickSensors = new EventEmitter<any>();
    constructor() { }

    ngOnInit() { }

    getColor(){
        return statusColor({working: this.working, active: this.active, shift_has_data: this.shiftHasData})
    }
}